import axios from '@lib/axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface RemoveRecipientProps {
	companyId: string;
	onSuccess?: () => void;
}

interface RemoveRecipientMutationParams {
	id: string;
}

export const useRemoveCompanyRecipient = ({
	companyId,
	onSuccess,
}: RemoveRecipientProps) => {
	const queryClient = useQueryClient();
	const {
		isPending,
		isError,
		error,
		mutate: onRemoveCompanyRecipient,
	} = useMutation({
		mutationFn: async ({ id }: RemoveRecipientMutationParams) => {
			try {
				await axios.delete(`recipients/${id}`);
			} catch (err) {
				throw new Error('Ocorreu um erro, tente novamente');
			}
		},
		onSuccess: () => {
      if (onSuccess) {
        onSuccess();
      }

			queryClient.invalidateQueries({ queryKey: ['company', companyId] });
		},
	});

	return { onRemoveCompanyRecipient, isPending, isError, error };
};
